import { galleryItems } from "../data/gallery";

const byPriorityAsc = (a, b) => {
  const pa = a.priority ?? "low";
  const pb = b.priority ?? "low";
  if (pa === "high" && pb !== "high") return -1;
  if (pb === "high" && pa !== "high") return 1;
  return 0;
};

export default function GalleryPreview() {
  const sortedGallery = [...galleryItems]
    .filter((item) => item.includeInPreview)
    .sort(byPriorityAsc);

  return (
    <section>
      <div className="flex items-center justify-between pt-5 pb-3">
        <h2 className="text-[#0e1b17] text-[22px] font-bold leading-tight tracking-[-0.015em] px-4 md:px-0 pb-3 pt-5">
          Our Gallery
        </h2>
        <a
          href="/gallery"
          className="text-sm font-semibold text-[#14b881] hover:underline whitespace-nowrap"
        >
          View All
        </a>
      </div>
      {/* Mobile: horizontal scroll | Desktop: grid */}
      <div
        className="md:hidden flex overflow-x-auto gap-3 p-4 [-ms-scrollbar-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        aria-label="Gallery slider"
      >
        {sortedGallery.map((item, i) => (
          <article
            key={item.id}
            className="bg-white rounded-xl border border-[#e7f3ef] shadow-sm overflow-hidden flex flex-col min-w-[15rem] w-60"
          >
            <div className="p-4 flex flex-col gap-2 flex-1 items-center justify-center">
              <img
                src={item.image}
                alt={item.category}
                className="w-full h-40 object-cover rounded-lg mb-2"
              />
            </div>
          </article>
        ))}
      </div>
      {/* Desktop: grid layout */}
      <div className="hidden md:grid lg:grid-cols-4 grid-cols-2 gap-4 p-4">
        {sortedGallery.map((item, i) => (
          <article
            key={item.id}
            className="bg-white rounded-xl border border-[#e7f3ef] shadow-sm overflow-hidden flex flex-col w-full"
          >
            <div className="p-4 flex flex-col gap-2 flex-1 items-center justify-center">
              <img
                src={item.image}
                alt={item.category}
                className="w-full h-40 object-cover rounded-lg mb-2"
              />
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
